import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormEnums } from "models/enums";
import { ExpandableSectionProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { CommentsFormTypes } from "models/formTypes";
import { CommentAndFileInputFormProps } from "models/propTypes/commentViewPropTypes";
//#endregion
//#region components
import GenericForm from "../../forms/genericForm";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { UtilsHelper } from "utils/helpers";

const CommentAndFileInpuForm: ForwardRefRenderFunction<FormHandles, CommentAndFileInputFormProps> = (props, ref) => {
  const {
    showPostWithoutImage,
    showMarkAsResolved,
    nonExpandable,
    onUploadedFilesChangeHandler,
    attachmentsHiddenCondition,
  } = props;

  return (
    <GenericForm<CommentsFormTypes.CommentWithFile>
      formRef={ref}
      {...props}
      fields={[
        {
          type: FormEnums.FormSectionType.EXPANDABLESECTION,
          extraProps: {
            alwaysOpen: true,
            borderless: true,
          } as ExpandableSectionProps,
          innerFields: {
            explanation: {
              label: TranslationKeys.Common.Answer,
              type: FormEnums.FormFieldType.TEXTAREA,
              icon: IconDefinitionConstants.WCommentDots,
              extraProps: {
                minRows: 1,
                maxRows: 5,
              },
            },
            markAsResolved: {
              label: TranslationKeys.SupportIssue.MarkAsResolved,
              type: FormEnums.FormFieldType.TOGGLE,
              descriptionText: TranslationKeys.SupportIssue.MarkAsResolvedHelperMessage,
              hidden: !showMarkAsResolved,
            },
          },
        },
        {
          label: !nonExpandable
            ? props.initialValues?.filesToUpload?.length
              ? TranslationKeys.Common.AttachedFiles
              : TranslationKeys.Common.AddFile
            : "",
          type: FormEnums.FormSectionType.EXPANDABLESECTION,
          extraProps: {
            borderless: true,
            alwaysOpen: nonExpandable,
          } as ExpandableSectionProps,
          hidden: (values: CommentsFormTypes.CommentWithFile) =>
            attachmentsHiddenCondition === "always" ||
            (attachmentsHiddenCondition === "untilHasMessage" && UtilsHelper.isEmpty(values.explanation)),
          innerFields: [
            {
              type: FormEnums.FormSectionType.FIELDGROUPSECTION,
              innerFields: {
                filesToUpload: {
                  label: "",
                  type: FormEnums.FormFieldType.FILEUPLOADER,
                  disabled: (values: CommentsFormTypes.CommentWithFile) =>
                    values.postWithoutPicture && !!showPostWithoutImage,
                  extraProps: { fileUploaderType: "full" },
                  onChangeHandler: onUploadedFilesChangeHandler,
                },
              },
            },
            {
              type: FormEnums.FormSectionType.FIELDGROUPSECTION,
              hidden: !showPostWithoutImage,
              innerFields: {
                postWithoutPicture: {
                  label: TranslationKeys.Common.BookWithoutImage,
                  type: FormEnums.FormFieldType.TOGGLE,
                  classes: { formControl: cssExports.inlineLabel },
                },
              },
            },
          ],
        },
      ]}
      hideSuccess
    />
  );
};

export default forwardRef(CommentAndFileInpuForm);
